import { get, isString, isUndefined } from 'lodash';

export const DYNAMIC_PARAMS_REGEX = /\${([a-zA-Z0-9._\-"'[\]]+)}/;

const DEFAULT_VALUES = {
    userId: -1,
};

// RequestContext can't exist outside of a Perseus app,
// so we need to pass it as a parameter to support unit tests for these functions
export const injectParamsToField = (context, field) => {
    if (!isString(field)) {
        return field;
    }

    const regex = new RegExp(DYNAMIC_PARAMS_REGEX, 'g');
    return field?.replace(regex, (match, p1) => {
        const value = get(context, p1, DEFAULT_VALUES[p1]);
        return !isUndefined(value) ? value : get(context.initialProps, p1, DEFAULT_VALUES[p1]);
    });
};

export const injectParamsToObject = (context, obj = {}) => {
    Object.entries(obj).forEach(([key, value]) => {
        obj[key] = injectParamsToField(context, value);
    });
};
